define([
	"./_Indentation",
	"./PluginFactory"
], function(_Indentation,PluginFactory) {

	return PluginFactory.declare(_Indentation, {
		"class": "csi-button-toggle csi-single-toggle",
		indentValue: "outdent",
		materialIcon: "format_indent_decrease",
		pluginName: "outdent",
		title: "CanvasDecreaseIndent"
	});
});
